import type { ReactNode } from 'react';

import { cx } from '@/shared/lib/cx';

import styles from './badge.module.scss';

/** Status label in the top-left corner of a photo ("Предзаказ", "В наличии"). */
export function Badge({
  children,
  tone = 'default',
  className,
}: {
  children: ReactNode;
  tone?: 'default' | 'accent';
  className?: string | undefined;
}) {
  return (
    <span className={cx(styles.badge, className)} data-tone={tone}>
      {children}
    </span>
  );
}

/** Small note in the bottom-right corner of a photo ("Референс", "Эскиз"). */
export function MediaTag({
  children,
  className,
}: {
  children: ReactNode;
  className?: string | undefined;
}) {
  return <span className={cx(styles.tag, className)}>{children}</span>;
}
